import { Subject } from 'rxjs';

export const slotSubject = new Subject<number>();
